import React from 'react';
import { IconProps } from './types';

export const KYCIcon = (props: IconProps) => {
  const { size = 14, color = '#F65C5C', style = {} } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 14 14'
    >
      <path
        fill={color}
        d='M7 12.833S11.667 10.5 11.667 7V2.917L7 1.167l-4.667 1.75V7C2.333 10.5 7 12.833 7 12.833z'
      />
      <path
        stroke='#FFEBED'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.2'
        d='M9.364 5l-3 3L5 6.636'
      />
    </svg>
  );
};
